/**
 * Prefix used to persist which CSAT surveys were already started for a user.
 */
export const CSAT_SURVEY_STORAGE_PREFIX = 'caixa:csat-survey:';

/**
 * Fallback used in the guard key when the logged user is not resolvable.
 *
 * Defensive only: a survey is started solely for a loaded user who accepted
 * the terms of use, so this is reached at most if the user state is cleared
 * between that check and the guard being written — in which case guarding per
 * device is still better than writing a key with no user in it.
 */
export const CSAT_SURVEY_ANONYMOUS_USER = 'anonymous';

/**
 * CSAT survey ids, as configured in the Intercom workspace.
 *
 * Each survey covers a product area, so it is shared by every route that
 * renders the components of that area.
 */
export const CSAT_SURVEYS = {
  /** Gestão de entradas e saídas — fluxo de caixa e lista de registros */
  CASH_MANAGEMENT: '68511439',
  /** Produtos Open Finance — cartão de crédito, linhas de crédito e investimentos */
  OPEN_FINANCE_PRODUCTS: '68512744',
  /** Relatórios — DFM e comparativo de resultados */
  REPORTS: '68512430',
} as const;

/**
 * Maps each application route to the CSAT survey that must be started on it.
 *
 * Routes absent from this map do not collect CSAT.
 */
export const CSAT_SURVEY_BY_ROUTE: Readonly<Record<string, string>> = {
  '/cash-flow': CSAT_SURVEYS.CASH_MANAGEMENT,
  '/cash-flow/list': CSAT_SURVEYS.CASH_MANAGEMENT,
  '/credit-cards': CSAT_SURVEYS.OPEN_FINANCE_PRODUCTS,
  '/credit-card-summary': CSAT_SURVEYS.OPEN_FINANCE_PRODUCTS,
  '/credit-lines': CSAT_SURVEYS.OPEN_FINANCE_PRODUCTS,
  '/investments': CSAT_SURVEYS.OPEN_FINANCE_PRODUCTS,
  '/results/monthly': CSAT_SURVEYS.REPORTS,
  '/results/comparative': CSAT_SURVEYS.REPORTS,
};
